import React from 'react';
import { componentService } from 'js/services/component.service';

export const LastLoginDate = React.lazy(() => import(/* webpackChunkName: "last-login-date" */ './LastLoginDate'));

// <hub2-last-login-date format="yyyy-MM-dd HH:mm:ss" tz="UTC+3"></hub2-last-login-date>
componentService.registerWebContentComponents({ LastLoginDate });
